import { MsalProvider } from '@azure/msal-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initAuth, msalInstance } from './auth';
import { config } from './config';
import './styles/app.css';

async function bootstrap(): Promise<void> {
  await initAuth();
  const root = createRoot(document.getElementById('root') as HTMLElement);
  const app = (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
  root.render(<StrictMode>{config.authDisabled ? app : <MsalProvider instance={msalInstance}>{app}</MsalProvider>}</StrictMode>);
}

void bootstrap();
